import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { ArrowPathRoundedSquareIcon, CalendarDaysIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import RoleCalibration from './rolecalibration';

import Departments from './departments';

const tabs = [
  { name: 'Teams', component: <Departments />, icon: CalendarDaysIcon },
  { name: 'Role Calibration', component: <RoleCalibration />, icon: CalendarDaysIcon },
 

];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {
  const [currentTabIndex, setCurrentTabIndex] = useState(1); // Default to the first tab index
  const navigate = useNavigate(); // Initialize useNavigate

  const handleTabChange = (index) => {
    setCurrentTabIndex(index);
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:hidden">
        {/* Mobile version - dropdown to select a tab */}
        <select
          value={tabs[currentTabIndex].name}
          onChange={(e) => {
            const selectedTab = tabs.find((tab) => tab.name === e.target.value);
            const index = tabs.indexOf(selectedTab);
            handleTabChange(index);
          }}
          aria-label="Select a tab"
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-indigo-900 outline outline-1 -outline-offset-1 outline-indigo-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          data-component="role-home-tabs"
          data-feature="select_tab_mobile"
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-indigo-500"
        />
      </div>

      <div className="hidden sm:block">
        {/* Desktop version - horizontal tab navigation */}
        <div className="border-b border-indigo-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                onClick={() => {
                  if (tab.url) {
                    navigate(tab.url); // Use navigate from react-router-dom to navigate to the URL
                  } else {
                    handleTabChange(index); // Handle tab switch for other tabs
                  }
                }}
                className={classNames(
                  currentTabIndex === index
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-indigo-500 hover:border-indigo-300 hover:text-indigo-700',
                  'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
                )}
                data-component="role-home-tabs"
                data-feature="select_tab_desktop"
                data-tab-name={tab.name}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Render the content of the selected tab */}
      <div className="mt-4">{tabs[currentTabIndex].component}</div>
    </div>
  );
}
